// SPDX-License-Identifier: AGPL-3.0-or-later
/**
 * Languages the patient-facing renderer supports at the chrome-string
 * level. A clinic's Questionnaire can carry translations for ANY
 * BCP-47 code via the `translation` extension — this list governs the
 * built-in dictionary keys (Submit button, validation messages, etc.)
 * and the patient-side language picker. Extend by adding the code
 * here and filling out `dictionary.ts`.
 *
 * Order is the order the picker presents to patients.
 */
export const SUPPORTED_LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'vi', label: 'Tiếng Việt' },
];
export function isSupportedLanguage(code) {
    return SUPPORTED_LANGUAGES.some((l) => l.code === code);
}
//# sourceMappingURL=languages.js.map